import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, serverTimestamp } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAIN9RLLOcRHuCoG0oXgGuKmxOoT7fkjXs",
  authDomain: "stg90-7de56.firebaseapp.com",
  projectId: "stg90-7de56",
  storageBucket: "stg90-7de56.firebasestorage.app",
  messagingSenderId: "375577279123",
  appId: "1:375577279123:web:98773bd7ed3dec407c2b66",
  measurementId: "G-FDJJ9HQK2V"
};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const timestamp = serverTimestamp;
export const storage = getStorage();
export default app;
